exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@keyframes spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.gm-button .btn{border-bottom-right-radius:4px;border-bottom-left-radius:4px;border-top-right-radius:4px;border-top-left-radius:4px}.gm-button>.btn-busy{position:relative}.gm-button>.btn-busy:after{opacity:0}.gm-button>.btn-busy .spinner-container{position:absolute;top:50%;left:50%;width:24px;height:24px;transform:translate(-50%,-50%)}.gm-button>.btn-busy .spinner:after{content:\"\"!important;border-radius:50%;width:24px;height:24px;border:.25rem solid hsla(0,0%,100%,.2);border-top-color:#fff;animation:spin 1s infinite linear;position:absolute;z-index:2;top:0;left:0}.gm-button>.btn-busy.btn-link div{display:inline}.gm-button>.btn-busy.btn-link .spinner-container{position:relative;display:inline-block;zoom:.65;top:auto;left:auto;transform:none}.gm-button>.btn-busy.btn-link .spinner:after{border:.25rem solid #eee!important;border-top-color:green!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./node_modules/greenmotion-shared/Components/shared/scss/button.scss
// module id = Qerx
// module chunks = 22